import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.667 4.667v-2c0-.369.299-.667.667-.667h5.333c.369 0 .667.298.667.667v2h2.667c.368 0 .666.298.666.666v9.334a.667.667 0 0 1-.666.666H2a.667.667 0 0 1-.667-.666V5.333c0-.368.298-.666.667-.666zm-2 7.333v2h10.667v-2zm0-1.333h10.667V6H2.667zm3.334-7.334v1.334h4V3.333zm1.333 5.334h1.333V10H7.334z"
    }, null, -1)
  ]))]))
}
export default { render: render }